import { render, staticRenderFns } from "./live-event.vue?vue&type=template&id=215ff66b&scoped=true"
import script from "./live-event.vue?vue&type=script&lang=js"
export * from "./live-event.vue?vue&type=script&lang=js"
import style0 from "./live-event.vue?vue&type=style&index=0&id=215ff66b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ff66b",
  null
  
)

export default component.exports